import { render } from "./FailurePaymentView.vue?vue&type=template&id=70be93b5"
import script from "./FailurePaymentView.vue?vue&type=script&lang=js"
export * from "./FailurePaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__